import Link from 'next/link';

import { PlusCircleIcon } from '@heroicons/react/24/solid';
import Container from '@/ui/container';

export default function StartAppsSection() {
	return (
		<Container data-sentry-element="Container" data-sentry-component="StartAppsSection" data-sentry-source-file="index.jsx">
			<div className="mt-12 md:px-12 lg:px-32">
				<div className="border pb-20 rounded-md shadow-xl">
					<h2 className="text-center text-xl bg-gray-200 shadow-sm py-4">
						Get Started by choosing the application type:
					</h2>
					<div className="flex flex-col space-y-4 items-center sm:flex-row wrap justify-evenly mt-12">
						<Link href="/application/family/new" passHref data-sentry-element="Link" data-sentry-source-file="index.jsx">
							<button>
								<div className=" flex flex-col px-8 py-12 space-y-4 justify-center items-center rounded-xl border-gray-300 border-2 bg-linear-to-tl from-emerald-600 to-emerald-200  shadow-md  transform transition-transform ease-in-out duration-200 hover:scale-105">
									<PlusCircleIcon className="h-10 w-10 text-white" data-sentry-element="PlusCircleIcon" data-sentry-source-file="index.jsx" />
									<h2 className="text-xl font-semibold text-white">
										Family Application
									</h2>
								</div>
							</button>
						</Link>
						<Link href="/application/senior/new" passHref data-sentry-element="Link" data-sentry-source-file="index.jsx">
							<button>
								<div className=" flex flex-col px-8 py-12 space-y-4 justify-center items-center rounded-xl border-gray-300 border-2 bg-linear-to-tl from-emerald-600 to-emerald-200  shadow-md transform transition-transform ease-in-out duration-200 hover:scale-105">
									<PlusCircleIcon className="h-10 w-10 text-white" data-sentry-element="PlusCircleIcon" data-sentry-source-file="index.jsx" />
									<h2 className="text-xl font-semibold text-white">
										Senior Application
									</h2>
								</div>
							</button>
						</Link>
					</div>
				</div>
			</div>
		</Container>
	);
}
